import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Container,
  Section,
  buttonStyles,
  fadeUp,
  stagger,
} from "@comai-portal/design-system";

/**
 * NotFoundPage — 404, on the ComOS design system.
 */
export function NotFoundPage() {
  return (
    <div className="bg-paper text-ink dark:bg-ink dark:text-paper">
      <Section>
        <Container width="prose" className="text-center">
          <motion.div variants={stagger} initial="hidden" animate="show">
            <motion.p variants={fadeUp} className="ds-eyebrow mb-5">
              404
            </motion.p>
            <motion.h1
              variants={fadeUp}
              className="font-display font-semibold tracking-[-0.02em] text-[clamp(2rem,5vw,3.5rem)] leading-[1.08] text-balance"
            >
              Page not found.
            </motion.h1>
            <motion.p
              variants={fadeUp}
              className="text-lead text-mute dark:text-mute-soft mt-6"
            >
              That route isn't part of the operating system.
            </motion.p>
            <motion.div variants={fadeUp} className="mt-9">
              <Link
                to="/"
                className={buttonStyles({ variant: "primary", size: "lg" })}
              >
                Back to home
              </Link>
            </motion.div>
          </motion.div>
        </Container>
      </Section>
    </div>
  );
}
